import React from 'react';
import { useLocation } from 'react-router-dom';
import GenericFeatureForm from '../shared/generic-feature-form';
import { ToggleSalesAPI } from '../../services/feature-api';
import { getFeatureConfig } from '../../config/featureDisplayConfig';

const config = getFeatureConfig('toggle-sales');

const ToggleSalesForm = (props) => {
  const location = useLocation();
  const editData = location.state?.editData || null;
  const isEdit = Boolean(editData);

  const handleSubmit = async (formData, accessToken) => {
    const result = isEdit
      ? await ToggleSalesAPI.update(accessToken, editData.id, formData)
      : await ToggleSalesAPI.create(accessToken, formData);
    if (!result.success) throw new Error(result.error || 'Lỗi khi lưu dữ liệu');
    return result;
  };

  return (
    <GenericFeatureForm
      title={isEdit ? 'Chỉnh sửa Bật doanh số' : 'Tạo mới Bật doanh số'}
      fields={config.formConfig.fields}
      onSubmit={handleSubmit}
      initialData={editData}
      backPath={config.path}
      accentColor={config.color}
      lockOnApproval={config.lockOnApproval}
      {...props}
    />
  );
};

export default ToggleSalesForm;
